export default "__VITE_ASSET__DXkv4SkD__"